import { PlusIcon } from '@heroicons/react/20/solid'

const AddFilter = ({ onClick, message = 'Add Filter' }: any) => {
  return (
    <button
      onClick={onClick}
      type="button"
      className="additional-button-add add-filter-button font-norma mt-2 text-xs leading-none text-blue-700"
    >
      <PlusIcon className="h-4 w-4" />
      {message}
    </button>
  )
}

AddFilter.displayName = 'AddFilter'

export default AddFilter
